import { AxiosRequestConfig } from 'axios';

import { groupFromBE } from '@common/api/groups';
import backend from '@common/backend';

const BASE = '/schedules';

export interface IGetSchedulesQuery {
	service_id?: number;
	location_id?: number;
	teacher_id?: number;
	program_id?: number;
	group_id?: number;
	search?: string;
	page?: number;
	limit?: number;
}

// @TODO: Remove when BE will be fixed
export const scheduleFromBE = ({ group, ...schedule }: any) => ({
	...schedule,
	group: groupFromBE(group),
});
const scheduleToBE = ({ service, location, group, teacher, ...schedule }: any) => ({
	// @TODO: Remove when BE will be fixed
	...schedule,
	location_id: location?.id || null,
	group_id: group?.id || null,
	service_id: service,
	main_teacher_id: teacher?.id || null,
});

export const getSchedules = async (query: IGetSchedulesQuery, config: AxiosRequestConfig = {}) =>
	backend
		.get(`${BASE}/`, {
			...config,
			params: query,
		})
		.then((schedules: any[]) => schedules.map(scheduleFromBE));

export const getScheduleList = async (query: IGetSchedulesQuery) =>
	backend
		.get(`${BASE}/list`, {
			params: query,
		})
		.then((schedules: any[]) => schedules.map(scheduleFromBE));

export const getSchedulesMentorUsers = async (query: IGetSchedulesQuery) =>
	backend
		.get(`${BASE}/get/mentor-users`, {
			params: query,
		})
		.then((schedules: any[]) => schedules.map(scheduleFromBE));

export const postSchedule = async (data: any) => backend.post(`${BASE}`, scheduleToBE(data));

export const getSchedule = async (id: number) => backend.get(`${BASE}/${id}`).then(scheduleFromBE);

export const saveSchedule = async (id: number, data: any) =>
	backend.put(`${BASE}/${id}`, data).then(scheduleFromBE);

export const deleteSchedule = async (id: number) => backend.delete(`${BASE}/${id}`);

export const getSimpleSchedulePrograms = async (id: number) =>
	backend.get(`${BASE}/${id}/programs`);
